import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeScreen from './screens/HomeScreen';
import ClassCartScreen from './screens/ClassCartScreen';
import SpaceCartScreen from './screens/SpaceCartScreen';
import ClassesScreen from './screens/ClassesScreen';
import SpacesScreen from './screens/SpacesScreen';
import CreateClassScreen from './screens/CreateClassScreen';
import CreateSpaceScreen from './screens/CreateSpaceScreen';
import ClassScreen from './screens/ClassScreen';
import SpaceScreen from './screens/SpaceScreen';
import ProfileScreen from './screens/ProfileScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import PaymentScreen from './screens/PaymentScreen';
import SpacePaymentScreen from './screens/SpacePaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import PlaceSpaceOrderScreen from './screens/PlaceSpaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import SpaceOrderScreen from './screens/SpaceOrderScreen';
import SpaceListScreen from './screens/SpaceListScreen';
import ClassListScreen from './screens/ClassListScreen';

const App = () => {
  return (
    <Router>
      <Header />
      <main className='py-3'>
        <Container>
          <Route path='/classes' component={ClassesScreen} exact />
          <Route path='/spaces' component={SpacesScreen} exact />
          <Route path='/placeorder' component={PlaceOrderScreen} exact />
          <Route
            path='/placespaceorder'
            component={PlaceSpaceOrderScreen}
            exact
          />
          <Route path='/payment' component={PaymentScreen} exact />
          <Route path='/spacepayment' component={SpacePaymentScreen} exact />
          <Route path='/classs/:id/edit' component={CreateClassScreen} exact />
          <Route path='/classs/:id' component={ClassScreen} exact />
          <Route path='/order/:id' component={OrderScreen} exact />
          <Route path='/spaceorder/:id' component={SpaceOrderScreen} exact />
          <Route path='/classcart/:id?' component={ClassCartScreen} exact />
          <Route path='/spacecart/:id?' component={SpaceCartScreen} exact />

          <Route path='/space/:id' component={SpaceScreen} exact />
          <Route path='/space/:id/edit' component={CreateSpaceScreen} exact />
          <Route path='/spacelist' component={SpaceListScreen} exact />
          <Route path='/classlist' component={ClassListScreen} exact />
          <Route path='/profile' component={ProfileScreen} exact />
          <Route path='/register' component={RegisterScreen} exact />
          <Route path='/login' component={LoginScreen} exact />
          <Route path='/' component={HomeScreen} exact />
        </Container>
      </main>

      <Footer />
    </Router>
  );
};

export default App;
